import styled from 'styled-components';
import ToggleButton from '@elementary/common-ui/components/ToggleButton';
import { fontSize, fontWeight, space } from '@elementary/common-ui/style/utils';

const DialogToggleButton = styled(ToggleButton)`
  gap: ${space('sm')};
  font-size: ${fontSize('lg')};
  svg path {
    fill: ${({ theme }) => theme.palette.icon.muted};
  }
  &.Mui-selected {
    background: ${({ theme }) => theme.palette.surface.selected};
    color: ${({ theme }) => theme.palette.accent.secondary};
    font-weight: ${fontWeight('medium')};

    svg path {
      fill: ${({ theme }) => theme.palette.accent.secondary};
    }
  }
  &:hover {
    background: ${({ theme }) => theme.palette.surface.muted} !important;
  }
`;

export default DialogToggleButton;
